import React from 'react';

const BriefcaseIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13 8.5C12.7239 8.5 12.5 8.72386 12.5 9V11H11.5V9C11.5 8.17157 12.1716 7.5 13 7.5H19C19.8284 7.5 20.5 8.17157 20.5 9V11H19.5V9C19.5 8.72386 19.2761 8.5 19 8.5H13Z'
      fill='currentColor'
    />
    <path
      d='M23.5 23H8.5C7.94772 23 7.5 22.5523 7.5 22V12C7.5 11.4477 7.94772 11 8.5 11H23.5C24.0523 11 24.5 11.4477 24.5 12V22C24.5 22.5523 24.0523 23 23.5 23Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.5 11.5C8.22386 11.5 8 11.7239 8 12V22C8 22.2761 8.22386 22.5 8.5 22.5H23.5C23.7761 22.5 24 22.2761 24 22V12C24 11.7239 23.7761 11.5 23.5 11.5H8.5ZM7 12C7 11.1716 7.67157 10.5 8.5 10.5H23.5C24.3284 10.5 25 11.1716 25 12V22C25 22.8284 24.3284 23.5 23.5 23.5H8.5C7.67157 23.5 7 22.8284 7 22V12Z'
      fill='currentColor'
    />
  </svg>
);

export default BriefcaseIcon;
